<template>
  <el-dialog :visible.sync="dialogVisible" center :show-close="false"
             append-to-body width="662px" top="0">
    <div class="login">
      <div class="leftBG">
        <strong>欢迎使用</strong>
        <h1>心理亦笙</h1>
        <div class="content">
          <span><i class="el-icon-check"></i>资深医生</span>
          <span><i class="el-icon-check"></i>线上咨询</span>
          <span><i class="el-icon-check"></i>心理测试</span>
          <span><i class="el-icon-check"></i>公益科普</span>
          <span><i class="el-icon-check"></i>地区资源</span>
        </div>
      </div>
      <el-form ref="userForm" :model="user" @keyup.enter.native="onSubmit">
        <h2 class="title">用户登录</h2>
        <div class="elInput">
          <el-input type="tel" v-model="user.mobile" placeholder="手机号/邮箱/用户名"></el-input>
        </div>
        <div class="elInput">
          <el-input type="password" v-model="user.pwd" placeholder="密码"></el-input>
        </div>
        <div class="flex elInput">
          <el-input type="text" v-model="user.code" placeholder="验证码"></el-input>
          <div class="flex getCode" @click="reloadCode('vcode-user')" style="cursor: pointer;">
            <img id="vcode-user" src="" alt="">
          </div>
        </div>
        <div class="elInput">
          <el-button type="primary" @click="onSubmit">登录</el-button>
        </div>
        <div class="elInput flex select">
          <el-checkbox v-model="user.checked">下次自动登录</el-checkbox>
          <span><router-link to="/forget">忘记密码</router-link>|<router-link
              to="/registered">去注册</router-link></span>
        </div>
      </el-form>
    </div>

    <!--<el-tab-pane label="医生用户登录" name="doctor">
      <el-form ref="doctorForm" :model="doctor">
        <div class="elInput">
          <el-input type="tel" v-model="doctor.mobile" placeholder="手机号"></el-input>
        </div>
        <div class="elInput">
          <el-input type="password" v-model="doctor.pwd" placeholder="密码"></el-input>
        </div>
        <div class="flex elInput">
          <el-input type="text" v-model="doctor.code" placeholder="验证码"></el-input>
          <div class="flex getCode" @click="reloadCode('vcode')" style="cursor: pointer;">
            <img id="vcode" src="" alt="">
            &lt;!&ndash;									<img src="../assets/img/refresh.png" alt="" width="20" @click="reloadCode('vcode')">&ndash;&gt;
          </div>
        </div>
        <div class="elInput">
          <el-button type="primary" @click="onSubmit">登录</el-button>
        </div>
        <div class="elInput flex select">
          <el-checkbox v-model="doctor.checked">下次自动登录</el-checkbox>
          <span><router-link to="/forget">忘记密码</router-link>|<router-link
              to="/registered">去注册</router-link></span>
        </div>
      </el-form>
    </el-tab-pane>-->
  </el-dialog>
</template>

<script>
import SysCons from '@/api/common';
import qs from 'qs';

export default {
  name: "loginDialog",
  data() {
    return {
      dialogVisible: false,
      activeName: 'user',
      user: {
        mobile: '',
        pwd: '',
        code: '',
        checked: false,
      },
      /* doctor: {
           mobile: '',
           pwd: '',
           code: '',
           checked: false,
       },*/
    }
  },
  inject: ['reload'],
  methods: {
    onSubmit() {
      let vm = this;
      // 校验信息
      let username = '';
      let password = '';
      let token = '';
      let code = '';
      let userType = 0;
      if (this.activeName == 'user') {
        username = this.user.mobile;
        password = this.user.pwd;
        token = $('img#vcode-user').attr("key");
        code = this.user.code;
        /*userType = 1;
      } else if (this.activeName == 'doctor') {
        username = this.doctor.mobile;
        password = this.doctor.pwd;
        token = $('img#vcode').attr("key");
        code = this.doctor.code;
        userType = 2;*/
      }
      if ($.trim(username).length === 0) {
        this.$message.warning("用户名不能为空");
        return;
      }
      if ($.trim(password).length === 0) {
        this.$message.warning("密码不能为空");
        return;
      }
      if ($.trim(code).length === 0) {
        this.$message.warning("验证码不能为空");
        return;
      } else if ($.trim(code).length !== 4) {
        this.$message.warning("验证码错误");
        return;
      }
      // 获取token
      let params = {
        grant_type: "password",
        // username: username + "#" + userType,
        username: username + "#0",
        password: password,
        scope: "all",
        token: token,
        code: code,
        client_id: "web",
        client_secret: "secret"
      };
      this.$ajax.post(SysCons.api.login, qs.stringify(params))
          .then((res) => {
            if (res.data && res.data.access_token) {
              localStorage.setItem("access_token", res.data.access_token);
              localStorage.setItem("refresh_token", res.data.refresh_token);
              localStorage.setItem("expires_in", res.data.expires_in);
              localStorage.setItem("get_token_date", new Date().getTime());


              vm.$ajax.post(SysCons.api.current + '?type=1')
                  .then((res) => {
                    if (res.data.status == 'success') {
                      localStorage.setItem("curUid", res.data.data.uid);
                      localStorage.setItem("name", res.data.data.name);
                      localStorage.setItem("headImg", res.data.data.img);
                      localStorage.setItem("account", res.data.data.account);
                      localStorage.setItem("user_type", res.data.data.type);
                      vm.$router.app.$children[0].refreshNav();
                    }
                  });

              if (vm.successUrl) {
                vm.dialogVisible = false;
                vm.$parent.$router.push(vm.successUrl);
                if (vm.successUrl === '/index') {
                  vm.$parent.showAddFeedbackDialog = true;
                }
                return;
              }

              vm.$parent.reload();

              // vm.$parent.$refs.headerCommon.checkLoginStatus();
              // vm.$parent.$parent.$refs.headerCommon.checkLoginStatus();
              // if (vm.activeName == 'doctor') {
              //     vm.$router.push({path: "/index/doctor/" + params.username});
              // } else {
              //     vm.$router.push('/index')
              // }
            } else {
              vm.$message({
                type: "error", message: res.data.error_description, onClose: () => {
                  vm.reload()
                }
              })
            }
          }).catch((err) => {
        vm.$message.error(err)
      })
      /*$.ajax({
          url: SysCons.api.login,
          type: 'POST',
          data: params,
          success: (res) => {
              if (res.access_token) {
                  localStorage.setItem("user_type", vm.activeName)
                  localStorage.setItem("account", params.username)
                  localStorage.setItem("access_token", res.access_token);
                  localStorage.setItem("refresh_token", res.refresh_token);
                  localStorage.setItem("expires_in", res.expires_in);
                  localStorage.setItem("get_token_date", new Date().getTime());

                  vm.$parent.reload();
                  vm.$parent.$parent.$refs.headerCommon.checkLoginStatus();
                  if (vm.activeName == 'doctor') {
                      vm.$router.push({path: "/index/doctor/" + params.username});
                  } else {
                      vm.$router.push('/index')
                  }
              } else {
                  vm.$message({
                      type: "error", msg: res.message, onClose: () => {
                          vm.reload()
                      }
                  })
              }
          },
          error: (XMLHttpRequest, textStatus, errorThrown) => {
              vm.$message({
                  type: "error", msg: XMLHttpRequest.responseJSON.error_description, onClose: () => {
                      vm.reload()
                  }
              })
              // layer.msg(XMLHttpRequest.responseJSON.error_description);
              // reloadCode();
          }
      });*/
    },
    handleClick(tab) {
      if (tab.name == 'user') {
        this.reloadCode('vcode-user')
        this.user = {
          mobile: '',
          pwd: '',
          code: '',
          checked: false,
        }
      } else {
        this.reloadCode('vcode')
        this.doctor = {
          mobile: '',
          pwd: '',
          code: '',
          checked: false,
        }
      }
    },
    reloadCode(id) {
      this.$ajax.post(SysCons.api.captcha).then((res) => {
        if (res.data.status === 'success') {
          $("img#" + id).attr("src", res.data.data);
          $("img#" + id).attr("key", res.data.token);
        }
      });
    }
  },
  beforeMount() {
    // this.reloadCode('vcode-user')
  },
  mounted() {
    // this.reloadCode('vcode-user')
  }
}
</script>


<style scoped lang="scss">
@import '../assets/css/login.scss';

.centerPage {
  width: auto;
  min-height: auto;
}

::v-deep .el-dialog__header {
  display: none;
}

::v-deep .el-dialog {
  background: transparent;
  box-shadow: none;

  .el-dialog__body {
    padding: 0;
  }

}
</style>
